"use client";

import { Card, Form, Table, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState } from "react";

const courseData = [
  {
    id: "#854",
    courseName: "IT Lab Solutions Ltd",
    instructorImg: "/images/user-6.jpg",
    instructorName: "Admin",
    enrolled: 180,
    startDate: "12 Feb 2026",
    endDate: "20 Feb 2026",
    price: "Trial",
  },

  {
    id: "#854",
    courseName: "SBS Limited",
    instructorImg: "/images/user-6.jpg",
    instructorName: "Admin",
    enrolled: 180,
    startDate: "24 Jan 2026",
    endDate: "30 Mar 2026",
    price: "Trial",
  },
  
];

const Courses = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(courseData.length / itemsPerPage);

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const displayedCourses = courseData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-0">
          <div className="p-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
              <h3 className="mb-0">Organizations List</h3>

              <Form.Select
                className="month-select form-control p-0 h-auto border-0"
                aria-label="Default select example"
              >
                <option defaultValue="0">Select</option>
                <option defaultValue="1">Expired</option>
                <option defaultValue="2">Trial</option>
                <option defaultValue="3">Inactive</option>
              </Form.Select>
            </div>
          </div>

          <div className="default-table-area style-two all-projects">
            <div className="table-responsive">
              <Table className="align-middle">
                <thead>
                  <tr>

                    <th scope="col">Organization Name</th>
                    <th scope="col">Owner</th>

                    <th scope="col">Join Date</th>
                    <th scope="col">Package Expire</th>
                    <th scope="col">Package</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {displayedCourses.map((defaultValue, i) => (
                    <tr key={i}>

                      <td>
                        <Link to={defaultValue.detailsLink}>
                          {defaultValue.courseName}
                        </Link>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <img
                              src={defaultValue.instructorImg}
                              className="wh-34 rounded-circle"
                              alt="user"
                              width={34}
                              height={34}
                            />
                          </div>
                          <div className="flex-grow-1 ms-2 position-relative top-1">
                            <h6 className="mb-0 fs-14 fw-medium">
                              {defaultValue.instructorName}
                            </h6>
                          </div>
                        </div>
                      </td>
                      <td className="text-body">{defaultValue.startDate}</td>
                      <td className="text-body">{defaultValue.endDate}</td>
                      <td>{defaultValue.price}</td>
                      <td>
                        <div className="d-flex align-items-center gap-1">
                          <Link to={defaultValue.detailsLink}>
                            <button className="ps-0 border-0 bg-transparent lh-1 position-relative top-2">
                              <span className="material-symbols-outlined fs-16 text-primary">
                                visibility
                              </span>
                            </button>
                          </Link>
                          <button className="ps-0 border-0 bg-transparent lh-1 position-relative top-2">
                            <span className="material-symbols-outlined fs-16 text-body">
                              edit
                            </span>
                          </button>
                          <button className="ps-0 border-0 bg-transparent lh-1 position-relative top-2">
                            <span className="material-symbols-outlined fs-16 text-danger">
                              delete
                            </span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="p-4 pt-lg-4">
              <div className="d-flex justify-content-center justify-content-sm-between align-items-center text-center flex-wrap gap-2 showing-wrap">
                <span className="fs-12 fw-medium">
                  Showing {startIndex + 1} to{" "}
                  {Math.min(startIndex + itemsPerPage, courseData.length)} of{" "}
                  {courseData.length} Results
                </span>

                <nav aria-label="Page navigation example">
                  <ul className="pagination mb-0 justify-content-center">
                    <li
                      className={`page-item ${currentPage === 1 && "disabled"}`}
                    >
                      <Button
                        className="page-link icon"
                        onClick={handlePrevPage}
                        disabled={currentPage === 1}
                      >
                        <span className="material-symbols-outlined">
                          keyboard_arrow_left
                        </span>
                      </Button>
                    </li>
                    <li
                      className={`page-item ${
                        currentPage === totalPages && "disabled"
                      }`}
                    >
                      <Button
                        className="page-link icon"
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                      >
                        <span className="material-symbols-outlined">
                          keyboard_arrow_right
                        </span>
                      </Button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default Courses;
